/*
 *
 * Division reducer
 *
 */

import { fromJS } from "immutable"
import {
  HAS_DIVISIONS_WATCHER,
  HAS_DIVISIONS_SUCCESS,
  HAS_DIVISIONS_FAILED,
  GET_TABLE_WATCHER,
  GET_TABLE_SUCCESS,
  GET_TABLE_FAILED,
  GET_SUBDIVISIONS_TABLE_WATCHER,
  GET_SUBDIVISIONS_TABLE_SUCCESS,
  GET_SUBDIVISIONS_TABLE_FAILED,
  GET_DIVISIONS_UNASSIGNED_WATCHER,
  GET_DIVISIONS_UNASSIGNED_SUCCESS,
  GET_DIVISIONS_UNASSIGNED_FAILED,
  ADD_SUBDIVISION_TABLE_WATCHER,
  ADD_SUBDIVISION_TABLE_SUCCESS,
  ADD_SUBDIVISION_TABLE_FAILED,
  DELETE_SUBDIVISION_TABLE_WATCHER,
  DELETE_SUBDIVISION_TABLE_SUCCESS,
  DELETE_SUBDIVISION_TABLE_FAILED,
  GET_DIVISION_PARENTS_WATCHER,
  GET_DIVISION_PARENTS_SUCCESS,
  GET_DIVISION_PARENTS_FAILED,
  SELECT_DIVISION_SUPERIOR_WATCHER,
  SELECT_DIVISION_SUPERIOR_SUCCESS,
  SELECT_DIVISION_SUPERIOR_FAILED,
  DELETE_DIVISION_TABLE_WATCHER,
  GET_COLLABORATORS_TABLE_WATCHER,
  GET_COLLABORATORS_TABLE_SUCCESS,
  GET_COLLABORATORS_TABLE_FAILED,
  LEAVE_TABLE,
  DELETE_DIVISIONS_WATCHER,
  DELETE_DIVISIONS_FAILED,
  GET_TEMPLATE_DIVISION_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
  TOGGLE_TABLE_VIEW,
  DELETE_DIVISION_TABLE_FAILED,
  CHANGE_EXPANDED_ROWS,
  RESET_EXPANDED_ROWS,
  CREATE_DIVISION_WATCHER,
  CREATE_DIVISION_SUCCESS,
  CREATE_DIVISION_FAILED,
} from "./constants"

export const initialState = fromJS({
  hasDivisions: undefined,
  getDivisions: [],
  isLoadingDivisions: true,
  importedSummary: {},
  subdivisionsTable: [],
  divisionsUnassigned: [],
  isLoadingDivisionsUnassigned: true,
  messageDeleteSubdivision: "",
  divisionParentsTable: [],
  isLoadingDivisionParentsTable: true,
  isLoadingSelectDivisionSup: false,
  isLoadingCollaboratorsTable: true,
  collaboratorsTable: [],
  leave: false,
  isDownloading: false,
  isUploading: false,
  tableView: "1",
  treeData: [],
  expandedRows: [],
  lastOfTree: [],
  orgFirst: true,
  isLoadingCreate: false,
  reset: false,
})

function divisionReducer(state = initialState, action) {  
  switch (action.type) {
    case HAS_DIVISIONS_WATCHER:
      return state.set("hasDivisions", undefined).set("getDivisions", [])
    case HAS_DIVISIONS_SUCCESS:
      return state.set("hasDivisions", action.payload)
    case HAS_DIVISIONS_FAILED:
      return state.set("hasDivisions", undefined)
    case GET_TABLE_WATCHER:
      return state.set("isLoadingDivisions", true)
    case GET_TABLE_SUCCESS:
      if (action.payload.first) {
        return state
          .set("isLoadingDivisions", false)
          .set("getDivisions", action.payload.params)
          .set("treeData", action.payload.tree)
          .set("lastOfTree", action.payload.lastOfTree)
          .set("expandedRows", action.payload.expandedRows)
          .set("orgFirst", false)
      }
      return state
        .set("isLoadingDivisions", false)
        .set("getDivisions", action.payload.params)
        .set("treeData", action.payload.tree)
        .set("lastOfTree", action.payload.lastOfTree)

    case GET_TABLE_FAILED:
      return state.set("isLoadingDivisions", false)

    case GET_SUBDIVISIONS_TABLE_WATCHER:
      return state
        .set("subdivisionsTable", [])
        .set("isLoadingSubdivionsTable", true)
    case GET_SUBDIVISIONS_TABLE_SUCCESS:
      return state
        .set("isLoadingSubdivionsTable", false)
        .set("subdivisionsTable", action.payload)
    case GET_SUBDIVISIONS_TABLE_FAILED:
      return state
        .set("isLoadingSubdivionsTable", false)
        .set("subdivisionsTable", [])

    case GET_DIVISIONS_UNASSIGNED_WATCHER:
      return state
        .set("divisionsUnassigned", [])
        .set("isLoadingDivisionsUnassigned", true)
    case GET_DIVISIONS_UNASSIGNED_SUCCESS:
      return state
        .set("divisionsUnassigned", action.payload)
        .set("isLoadingDivisionsUnassigned", false)
    case GET_DIVISIONS_UNASSIGNED_FAILED:
      return state
        .set("divisionsUnassigned", [])
        .set("isLoadingDivisionsUnassigned", false)

    case ADD_SUBDIVISION_TABLE_WATCHER:
      return state.set("isLoadingSubdivionsTable", true)
    case ADD_SUBDIVISION_TABLE_SUCCESS:
      return state.set("isLoadingSubdivionsTable", false)
    case ADD_SUBDIVISION_TABLE_FAILED:
      return state.set("isLoadingSubdivionsTable", false)

    case DELETE_SUBDIVISION_TABLE_WATCHER:
      return state
        .set("messageDeleteSubdivision", "")
        .set("isLoadingSubdivionsTable", true)
    case DELETE_SUBDIVISION_TABLE_SUCCESS:
      return state
        .set("messageDeleteSubdivision", action.payload)
        .set("isLoadingSubdivionsTable", false)
    case DELETE_SUBDIVISION_TABLE_FAILED:
      return state.set("isLoadingSubdivionsTable", false)

    case GET_DIVISION_PARENTS_WATCHER:
      return state.set("isLoadingDivisionParentsTable", true)
    case GET_DIVISION_PARENTS_SUCCESS:
      return state
        .set("isLoadingDivisionParentsTable", false)
        .set("divisionParentsTable", action.payload)
    case GET_DIVISION_PARENTS_FAILED:
      return state
        .set("isLoadingDivisionParentsTable", false)
        .set("divisionParentsTable", [])

    case SELECT_DIVISION_SUPERIOR_WATCHER:
      return state
        .set("isLoadingSelectDivisionSup", true)
        .set("isLoadingDivisions", true)
    case SELECT_DIVISION_SUPERIOR_SUCCESS:
      return state.set("isLoadingSelectDivisionSup", false)
    case SELECT_DIVISION_SUPERIOR_FAILED:
      return state.set("isLoadingSelectDivisionSup", false)

    case GET_COLLABORATORS_TABLE_WATCHER:
      return state.set("isLoadingCollaboratorsTable", true)
    case GET_COLLABORATORS_TABLE_SUCCESS:
      return state
        .set("isLoadingCollaboratorsTable", false)
        .set("collaboratorsTable", action.payload)
    case GET_COLLABORATORS_TABLE_FAILED:
      return state
        .set("isLoadingCollaboratorsTable", false)
        .set("collaboratorsTable", [])

    case GET_TEMPLATE_DIVISION_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_FAILED:
      return state.set("isDownloading", false)

    case DELETE_DIVISIONS_WATCHER:
      return state.set("isLoadingDivisions", true)
    case DELETE_DIVISIONS_FAILED:
      return state.set("isLoadingDivisions", false)

    case DELETE_DIVISION_TABLE_WATCHER:
      return state.set("isLoadingDivisions", true)

    case DELETE_DIVISION_TABLE_FAILED:
      return state.set("isLoadingDivisions", false)
    case UPLOAD_TEMPLATE_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_SUCCESS:
      return state
        .set("isUploading", false)
        .set("importedSummary", action.payload)
    case UPLOAD_TEMPLATE_FAILED:
      return state.set("isUploading", false)
    case LEAVE_TABLE:
      return state.set("leave", action.payload)
    case TOGGLE_TABLE_VIEW:
      return state.set("tableView", action.payload)
    case CHANGE_EXPANDED_ROWS:
      return state.set("expandedRows", action.payload)
    case RESET_EXPANDED_ROWS:
      return state.set("expandedRows", []).set("orgFirst", true)
    case CREATE_DIVISION_WATCHER:
      return state.set("isLoadingCreate", true).set("reset", false)
    case CREATE_DIVISION_SUCCESS:
      return state.set("isLoadingCreate", false).set("reset", true)
    case CREATE_DIVISION_FAILED:
      return state.set("reset", false).set("isLoadingCreate", false)
    default:
      return state
  }
}

export default divisionReducer
